import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, FormControl, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from '../../../../components/common/DatePicker';
import AxiosConfig from '../../../../utilities/AxiosConfig';
import Naggy from '../../../../utilities/naggy/Naggy';
import snackBar from '../../../../utilities/snackBar/SnackBar';
import './VehicleDetails.css'

interface VehicleDetailsProps {
    details: any
    info: any
    fleetReference: any
    userId: any
    refreshAll: Function
}

type VehicleDetailsTypes = {
    info: any
    eventType: string
    VehicleNumber: string
    VehicleStatusTypeDescription: string
    VehicleStatusTypeId: string
    ProfitCenterLongDesc: string
    VinNumber: string
    TitleState: string
    TitleNumber: string
    Year: string
    Color: string
    Make: string
    Model: string
    Mileage: string
    DecalId: string
    MaintenanceNumber: string
    PurchaseDate: number
    PurchasePrice: string
    IsOwned: boolean
    LeaseNumber: string
    LeaseExpiration: number
    VehicleRentalClass: string
    RentalBaseRatePerDay: string
    RentalBaseRatePerWeek: string
    RentalBaseRatePerMonth: string
    RentalPickUpDate: number
    RentalDropOffDate: number
    RentalLicenseFees: string
    RentalAncillaryCharges: string
    RentalTaxes: string
    RegistrationExpiration: number
    RegistrationState: string
    License: string
    DispositionDate: number
    DispositionValue: string
    BuyerName: string
    BuyerAddress: string
    BuyerCity: string
    BuyerState: string
    BuyerZip: string
    BuyerPhone: string
    hasParams: boolean
    saving: boolean
    filteredModels: any
    confirmDiscard: boolean
}

class VehicleDetails extends Component<VehicleDetailsProps, VehicleDetailsTypes>{

    infoInterval: any
    queryParams: any = {}
    timeFormat = "YYYY-MM-DD HH:mm:ss"
    constructor(props: any) {
        super(props)
        this.state = {
            info: {},
            eventType: "",
            VehicleNumber: "",
            VehicleStatusTypeDescription: "",
            VehicleStatusTypeId: "",
            ProfitCenterLongDesc: "",
            TitleState: "",
            VinNumber: "",
            TitleNumber: "",
            Year: "",
            Color: "",
            Make: "",
            Model: "",
            Mileage: "",
            DecalId: "",
            MaintenanceNumber: "",
            PurchaseDate: 0,
            PurchasePrice: "",
            IsOwned: false,
            LeaseNumber: "",
            LeaseExpiration: 0,
            VehicleRentalClass: "",
            RentalBaseRatePerDay: "",
            RentalBaseRatePerWeek: "",
            RentalBaseRatePerMonth: "",
            RentalPickUpDate: 0,
            RentalDropOffDate: 0,
            RentalLicenseFees: "",
            RentalAncillaryCharges: "",
            RentalTaxes: "",
            RegistrationExpiration: 0,
            RegistrationState: "",
            License: "",
            DispositionDate: 0,
            DispositionValue: "",
            BuyerName: "",
            BuyerAddress: "",
            BuyerCity: "",
            BuyerState: "",
            BuyerZip: "",
            BuyerPhone: "",
            hasParams: false,
            saving: false,
            filteredModels: [],
            confirmDiscard: false
        }
    }

    componentDidMount() {
        this.infoInterval = setInterval(this.waitVehicleInfo, 100)
    }

    componentWillUnmount() {
        clearInterval(this.infoInterval)
        this.resetCloseBtns()
    }

    waitVehicleInfo = () => {
        if (Object.keys(this.props.info).length > 0) {
            this.queryParams = this.props.info
            this.setState({
                VehicleNumber: this.props.info.VehicleNumber || "",
                VehicleStatusTypeDescription: this.props.details.VehicleStatusTypeDescription || "",
                VehicleStatusTypeId: this.props.info.VehicleStatusTypeId || "",
                ProfitCenterLongDesc: this.props.details.ProfitCenterLongDesc || "",
                TitleState: this.props.info.TitleState || "",
                VinNumber: this.props.info.VinNumber || "",
                TitleNumber: this.props.info.TitleNumber || "",
                Year: this.props.info.Year || "",
                Color: this.props.info.Color || "",
                Make: this.props.info.Make || "",
                Model: this.props.info.Model || "",
                Mileage: this.props.info.Mileage || "",
                DecalId: this.props.info.DecalId || "",
                MaintenanceNumber: this.props.info.MaintenanceNumber || "",
                PurchaseDate: this.props.info.PurchaseDate || "",
                PurchasePrice: this.props.info.PurchasePrice || "",
                IsOwned: this.props.info.IsOwned || "",
                LeaseNumber: this.props.info.LeaseNumber || "",
                LeaseExpiration: this.props.info.LeaseExpiration || "",
                RentalBaseRatePerDay: this.props.info.RentalBaseRatePerDay || "",
                RentalBaseRatePerWeek: this.props.info.RentalBaseRatePerWeek || "",
                RentalBaseRatePerMonth: this.props.info.RentalBaseRatePerMonth || "",
                RentalPickUpDate: this.props.info.RentalPickUpDate || "",
                RentalDropOffDate: this.props.info.RentalDropOffDate || "",
                RentalLicenseFees: this.props.info.RentalLicenseFees || "",
                RentalAncillaryCharges: this.props.info.RentalAncillaryCharges || "",
                RentalTaxes: this.props.info.RentalTaxes || "",
                RegistrationExpiration: this.props.info.RegistrationExpiration || "",
                RegistrationState: this.props.info.RegistrationState || "",
                License: this.props.info.License || "",
                DispositionDate: this.props.info.DispositionDate || "",
                DispositionValue: this.props.info.DispositionValue || "",
                BuyerName: this.props.info.BuyerName || "",
                BuyerAddress: this.props.info.BuyerAddress || "",
                BuyerCity: this.props.info.BuyerCity || "",
                BuyerZip: this.props.info.BuyerZip || "",
                BuyerPhone: this.props.info.BuyerPhone || "",
            })
            if (this.props.fleetReference.vehicleRentalClasses.length > 0 && this.props.info.VehicleRentalClassId) {
                for (let i = 0; i < this.props.fleetReference.vehicleRentalClasses.length; i++) {
                    if (this.props.fleetReference.vehicleRentalClasses[i].id + "" === this.props.info.VehicleRentalClassId + "") {
                        this.setState({ VehicleRentalClass: this.props.fleetReference.vehicleRentalClasses[i].text })
                    }
                }
            }
            if (this.props.fleetReference.states.length > 0 && this.props.info.BuyerState !== "-1") {
                for (let i = 0; i < this.props.fleetReference.states.length; i++) {
                    if ((this.props.fleetReference.states[i].id + "").trim() === (this.props.info.BuyerState + "").trim()) {
                        this.setState({ BuyerState: this.props.fleetReference.states[i].text })
                    }
                }
            } else {
                this.setState({ BuyerState: "*NA*" })
            }

            if (this.props.info.VehicleMakeId) {
                this.getModels(this.props.info.VehicleMakeId)
            }

            clearInterval(this.infoInterval)
        }
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    handleChange = (event: { target: { value: any } }) => {
        const eventTypes = Object.keys(this.state)
        for (let i = 0; i < eventTypes.length; i++) {
            if (this.state.eventType === eventTypes[i]) {
                const param: object = { [eventTypes[i]]: event.target.value }
                this.setState(param)
                this.appendParams(param)
            }
        }
    }

    appendParams = (param: object) => {
        let paramKey = Object.keys(param)
        let searchTearm = Object.values(param)
        this.queryParams[paramKey[0]] = searchTearm[0] + ""
        if (!this.state.hasParams) {
            this.setState({ hasParams: true })
            let closeBtn = document.getElementById("fleet-overview-close-btn")
            let closeEditingBtn = document.getElementById("fleet-overview-close-btn-editing")
            if (closeBtn) {
                closeBtn.style.display = "none"
            }
            if (closeEditingBtn) {
                closeEditingBtn.style.display = "block"
                closeEditingBtn.onclick = this.discardNag
            }
        }
    }

    cleanParams = () => {
        for (let [key] of Object.entries(this.queryParams)) {
            if (this.queryParams[key] === "") {
                this.queryParams[key] = null
            }
        }
        return this.queryParams
    }

    updateDropdown = (param: object) => {
        this.setState(param)
    }

    handlePurchaseDate = (val: number) => {
        this.setState({ PurchaseDate: val.valueOf() })
        this.appendParams({ PurchaseDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleLeaseExpirationDate = (val: number) => {
        this.setState({ LeaseExpiration: val.valueOf() })
        this.appendParams({ LeaseExpiration: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleRentalPickupDate = (val: number) => {
        this.setState({ RentalPickUpDate: val.valueOf() })
        this.appendParams({ RentalPickUpDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleRentalDropOffDate = (val: number) => {
        this.setState({ RentalDropOffDate: val.valueOf() })
        this.appendParams({ RentalDropOffDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleRegistrationExpirationDate = (val: number) => {
        this.setState({ RegistrationExpiration: val.valueOf() })
        this.appendParams({ RegistrationExpiration: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleDispositionDate = (val: number) => {
        this.setState({ DispositionDate: val.valueOf() })
        this.appendParams({ DispositionDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    setModel = (param: any, placeHolderText: string) => {
        this.setState({ Model: placeHolderText })
        this.appendParams(param)
        this.appendParams({ Model: placeHolderText })
    }

    setMake = (param: any, placeHolderText: string) => {
        this.queryParams.VehicleModel = ""
        this.queryParams.VehicleModelId = ""
        this.queryParams.Model = ""
        this.setState({ Make: placeHolderText, Model: "", filteredModels: [] })
        this.appendParams(param)
        this.appendParams({ Make: placeHolderText })
        if (param.VehicleMakeId !== "") {
            this.getModels(param.VehicleMakeId)
        } else {
            this.setModel([{ VehicleModelId: "" }], "--Select Model--")
            this.setState({ filteredModels: [] })
        }
    }

    getModels = (modelId: number) => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getVehicleModelsByMake/" + modelId, AxiosConfig.configValue())
            .then(res => {
                let models: any = res.data.vehicleModels.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1)
                this.setState({ filteredModels: models })
            }).catch(err => {
                //console.log(err)
            })
    }

    toggleOwned = (type: string) => {
        let str = type.split("-")
        if (str[1] === "t") {
            const obj: object = { [str[0]]: true }
            this.setState(obj)
            this.appendParams(obj)
        } else {
            const obj: object = { [str[0]]: false }
            this.setState(obj)
            this.appendParams(obj)
        }
    }

    saveChanges = () => {
        this.setState({ saving: true })
        this.resetCloseBtns()
        let requestBody = this.cleanParams()
        requestBody.ModifyDate = Date.now()
        requestBody.ModifiedBy = this.props.userId
        let vin = requestBody.VinNumber
        requestBody.VinNumber = vin.toUpperCase()
        axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateVehicleInformation", requestBody, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false, hasParams: false })
                snackBar({ text: "Vehicle Details Updated", type: "success", timeout: 3000 })
                this.props.refreshAll("details")
                this.updateTable()
            })
            .catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
                this.setState({ saving: false })
                snackBar({ text: "Error updating details", type: "error", timeout: 3000 })
            })
    }

    updateTable = () => {
        let tableColumns = ["Year", "VinNumber", "VehicleStatusTypeDescription", "ProfitCenterLongDesc"]
        for (let i = 0; i < tableColumns.length; i++) {
            let column = document.getElementById(`vehicle-table-${tableColumns[i]}-column-${this.state.VehicleNumber}`)
            if (column) {
                //@ts-ignore
                column.innerHTML = this.state[tableColumns[i]]
            }
        }
        let makeModel = document.getElementById(`vehicle-table-make-column-${this.state.VehicleNumber}`)
        if (makeModel) {
            makeModel.innerHTML = `${this.state.Make} ${this.state.Model}`
        }
    }

    discardNag = () => {
        this.setState({ confirmDiscard: true })
    }

    discard = (discard: boolean) => {
        let closeBtn = document.getElementById("fleet-overview-close-btn")
        let closeEditingBtn = document.getElementById("fleet-overview-close-btn-editing")
        if (discard) {
            if (closeBtn) {
                closeBtn.style.display = "block"
                setTimeout(function () {
                    closeBtn?.click()
                }, 100)
            }
            if (closeEditingBtn) {
                closeEditingBtn.style.display = "none"
            }
        } else {
            if (closeBtn) {
                closeBtn.style.display = "none"
            }
            if (closeEditingBtn) {
                closeEditingBtn.style.display = "block"
            }
            this.setState({ confirmDiscard: false })
        }
    }

    resetCloseBtns = () => {
        let closeBtn = document.getElementById("fleet-overview-close-btn")
        let closeEditingBtn = document.getElementById("fleet-overview-close-btn-editing")
        if (closeBtn) {
            closeBtn.style.display = "block"
        }
        if (closeEditingBtn) {
            closeEditingBtn.style.display = "none"
        }
    }

    render() {

        // //console.log("props: ", this.props)
        // //console.log("state: ", this.state)
        // //console.log("params: ", this.queryParams)

        return (
            <div className="VehicleDetails">
                {this.state.confirmDiscard && <Modal id="fleet-new-vehicle-discard-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        Are you sure you want to quit? Any unsaved changes will be lost.
                    </Modal.Header>
                    <Modal.Footer>
                        <div id="fleet-new-vehicle-discard-modal-footer" >
                            <Button id="fleet-new-vehicle-discard-modal-footer-quit-btn" variant="danger" onClick={() => this.discard(true)}>Quit</Button>
                            <Button id="fleet-new-vehicle-discard-modal-footer-back-btn" variant="secondary" onClick={() => this.discard(false)}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                <div className="R1-Header">
                    <div id="vehicle-details-column-header">
                        <p >General Info</p>
                    </div>
                    <div id="vehicle-details-column-header">
                        <p >Title Info</p>
                    </div>
                    <div id="vehicle-details-column-header">
                        <p >Purchase Info</p>
                    </div>
                </div>
                <div className="Vehicle-Details-R1">
                    <div className="Vehicle-Details-C1">
                        {this.state.hasParams && <Button variant="outline-success" id="vehicle-details-save" onClick={() => this.saveChanges()}>
                            <div className="Vehicle-Details-Save-Wrapper">
                                <p>Save</p>
                                <span className="material-icons">save</span>
                                {this.state.saving && <Spinner animation="border" variant="secondary" size="sm" />}
                            </div>
                        </Button>}
                        <p>Vehicle Number</p>
                        <FormControl onFocus={() => this.setEventType("VehicleNumber")}
                            placeholder={this.props.details.VehicleNumber || "*NA*"}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            // onChange={this.handleChange}
                            readOnly={true}
                            value={this.state.VehicleNumber}
                            name="MaintenanceNum"
                        />
                        <p>Status</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.VehicleStatusTypeDescription || "*NA*" }}
                            options={this.props.fleetReference.vehicleStatusTypes.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.appendParams({ VehicleStatusTypeId: parseInt(item.value) })
                                this.updateDropdown({ VehicleStatusTypeDescription: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Profit Center</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.ProfitCenterLongDesc || "*NA*" }}
                            options={this.props.fleetReference.profitCenters.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.appendParams({ ProfitCenterId: parseInt(item.value) })
                                this.updateDropdown({ ProfitCenterLongDesc: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Last Driver: {this.props.details.LastDriver}</p>
                        <p>Last Mileage: {this.props.details.Mileage}</p>
                    </div>
                    <div className="Vehicle-Details-C2">
                        <p>Vin</p>
                        <FormControl onFocus={() => this.setEventType("VinNumber")}
                            placeholder={this.props.details.VinNumber || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.VinNumber.toUpperCase()}
                        />
                        <p>Vehicle Make</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.Make || "*NA*" }}
                            options={this.props.fleetReference.vehicleMakes.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                // this.appendParams({ VehicleMakeId: item.value })
                                // this.appendParams({ Make: item.label })
                                this.setMake({ VehicleMakeId: item.value }, item.label)
                                this.updateDropdown({ Make: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Vehicle Model</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.Model || "*NA*" }}
                            options={this.state.filteredModels.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                // this.appendParams({ VehicleModelId: item.value })
                                // this.appendParams({ Model: item.label })
                                this.setModel({ VehicleModelId: item.value }, item.label)
                                this.updateDropdown({ Model: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Vehicle Year</p>
                        <FormControl onFocus={() => this.setEventType("Year")}
                            placeholder={this.state.Year || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.Year}
                        />
                        <p>Title State</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.TitleState || "*NA*" }}
                            options={this.props.fleetReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.appendParams({ TitleState: item.label })
                                this.updateDropdown({ TitleState: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Title Number</p>
                        <FormControl onFocus={() => this.setEventType("TitleNumber")}
                            placeholder={this.state.TitleNumber || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.TitleNumber}
                        />
                        <p>Vehicle Color</p>
                        <FormControl onFocus={() => this.setEventType("Color")}
                            placeholder={this.state.Color || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.Color}
                        />
                        <p>Vehicle Mileage</p>
                        <FormControl onFocus={() => this.setEventType("Mileage")}
                            placeholder={this.state.Mileage || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.Mileage || ""}
                        />
                        <p>Drivers Hotline Decal #</p>
                        <FormControl onFocus={() => this.setEventType("DecalId")}
                            placeholder={this.state.DecalId || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.DecalId || ""}
                        />
                        <p>Maintenance #</p>
                        <FormControl onFocus={() => this.setEventType("MaintenanceNumber")}
                            placeholder={this.state.MaintenanceNumber || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.MaintenanceNumber || ""}
                        />
                        <div className="Vehicle-Details-Vanity-Bar"></div>
                    </div>
                    <div className="Vehicle-Details-C3">
                        <p>Purchase Date</p>
                        <DatePicker value={this.state.PurchaseDate || ""} onChange={this.handlePurchaseDate} type="input" useCloseCallback />
                        <p>Original Purchase Price</p>
                        <FormControl onFocus={() => this.setEventType("PurchasePrice")}
                            placeholder={this.state.PurchasePrice || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.PurchasePrice || ""}
                        />
                        <p>Fully Owned</p>
                        {this.state.IsOwned && <Button variant="outline-light" id="vehicle-details-is-owned-t" onClick={() => this.toggleOwned("IsOwned-f")}>
                            <span className="material-icons">done</span>
                        </Button>}
                        {!this.state.IsOwned && <Button variant="outline-light" id="vehicle-details-is-owned-f" onClick={() => this.toggleOwned("IsOwned-t")}>
                            <span className="material-icons">close</span>
                        </Button>}
                        <p>Lease #</p>
                        <FormControl onFocus={() => this.setEventType("LeaseNumber")}
                            placeholder={this.state.LeaseNumber || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.LeaseNumber || ""}
                        />
                        <p>Lease Expiration</p>
                        <DatePicker value={this.state.LeaseExpiration || ""} onChange={this.handleLeaseExpirationDate} type="input" useCloseCallback />
                        <div className="Vehicle-Details-Vanity-Bar"></div>
                    </div>
                </div>
                <div className="R2-Header">
                    <div id="vehicle-details-column-header">
                        <p >Rental Info</p>
                    </div>
                    <div id="vehicle-details-column-header">
                        <p >Registration Info</p>
                    </div>
                    <div id="vehicle-details-column-header">
                        <p >Disposition Info</p>
                    </div>
                </div>
                <div className="Vehicle-Details-R2">
                    <div className="Vehicle-Details-C4">
                        <p>Vehicle Class Requested</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.VehicleRentalClass || "*NA*" }}
                            options={this.props.fleetReference.vehicleRentalClasses.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.appendParams({ VehicleRentalClassId: item.value })
                                this.updateDropdown({ VehicleRentalClass: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Base Rate Per Day</p>
                        <FormControl onFocus={() => this.setEventType("RentalBaseRatePerDay")}
                            placeholder={"$" + this.state.RentalBaseRatePerDay || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.RentalBaseRatePerDay || ""}
                        />
                        <p>Base Rate Per Week</p>
                        <FormControl onFocus={() => this.setEventType("RentalBaseRatePerWeek")}
                            placeholder={"$" + this.state.RentalBaseRatePerWeek || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.RentalBaseRatePerWeek || ""}
                        />
                        <p>Base Rate Month </p>
                        <FormControl onFocus={() => this.setEventType("RentalBaseRatePerMonth")}
                            placeholder={"$" + this.state.RentalBaseRatePerMonth || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.RentalBaseRatePerMonth || ""}
                        />
                        <p>Date Vehicle Picked Up</p>
                        <DatePicker value={this.state.RentalPickUpDate || ""} onChange={this.handleRentalPickupDate} type="input" useCloseCallback />
                        <p>Date Vehicle Returned</p>
                        <DatePicker value={this.state.RentalDropOffDate || ""} onChange={this.handleRentalDropOffDate} type="input" useCloseCallback />
                        <p>License Fees	</p>
                        <FormControl onFocus={() => this.setEventType("RentalLicenseFees")}
                            placeholder={"$" + this.state.RentalLicenseFees || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.RentalLicenseFees || ""}
                        />
                        <p>Ancillary Charges</p>
                        <FormControl onFocus={() => this.setEventType("RentalAncillaryCharges")}
                            placeholder={"$" + this.state.RentalAncillaryCharges || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.RentalAncillaryCharges || ""}
                        />
                        <p>Taxes</p>
                        <FormControl onFocus={() => this.setEventType("RentalTaxes")}
                            placeholder={"$" + this.state.RentalTaxes || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.RentalTaxes || ""}
                        />
                        <div className="Vehicle-Details-Vanity-Bar"></div>
                    </div>
                    <div className="Vehicle-Details-C5">
                        <p>Registration Expiration</p>
                        <DatePicker value={this.state.RegistrationExpiration || ""} onChange={this.handleRegistrationExpirationDate} type="input" useCloseCallback />
                        <p>Registration State</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.RegistrationState || "*NA*" }}
                            options={this.props.fleetReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.appendParams({ RegistrationState: item.value })
                                this.updateDropdown({ RegistrationState: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>License Plate Number</p>
                        <FormControl onFocus={() => this.setEventType("License")}
                            placeholder={this.state.License || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.License || ""}
                        />
                    </div>
                    <div className="Vehicle-Details-C6">
                        <p>Disposition Date</p>
                        <DatePicker value={this.state.DispositionDate || ""} onChange={this.handleDispositionDate} type="input" useCloseCallback />
                        <p>Disposition Value</p>
                        <FormControl onFocus={() => this.setEventType("DispositionValue")}
                            placeholder={this.state.DispositionValue || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.DispositionValue || ""}
                        />
                        <p>Buyer Name</p>
                        <FormControl onFocus={() => this.setEventType("BuyerName")}
                            placeholder={this.state.BuyerName || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.BuyerName || ""}
                        />
                        <p>Buyer Address</p>
                        <FormControl onFocus={() => this.setEventType("BuyerAddress")}
                            placeholder={this.state.BuyerAddress || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.BuyerAddress || ""}
                        />
                        <p>Buyer City</p>
                        <FormControl onFocus={() => this.setEventType("BuyerCity")}
                            placeholder={this.state.BuyerCity || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.BuyerCity || ""}
                        />
                        <p>Buyer State</p>
                        <Select
                            id="dropdown-basic-button-fleet-details-btn"
                            value={{ label: this.state.BuyerState || "*NA*" }}
                            options={this.props.fleetReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.appendParams({ BuyerState: item.value })
                                this.updateDropdown({ BuyerState: item.label })
                            }}
                            menuPosition="fixed"
                        />
                        <p>Buyer Zip</p>
                        <FormControl onFocus={() => this.setEventType("BuyerZip")}
                            placeholder={this.state.BuyerZip || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.BuyerZip || ""}
                        />
                        <p>Buyer Phone</p>
                        <FormControl onFocus={() => this.setEventType("BuyerPhone")}
                            placeholder={this.state.BuyerPhone || "*NA*"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.BuyerPhone || ""}
                        />
                        <div className="Vehicle-Details-Vanity-Bar"></div>
                    </div>
                </div>
                <Naggy
                    disabledElements={["double-panel-table", "vehicle-search-wrapper"]}
                    isDirty={this.state.hasParams}
                    toggleDirty={() => ({})}
                    discard={() => this.discard(true)}
                    // message={this.discardMsg}
                    message={"Discard Changes?"}
                />
            </div>
        )
    }
}

export default VehicleDetails